import { Component, OnInit } from '@angular/core';
import { AlertService } from '../../_services/alert.service';
import { ApiIntegration } from '../../_services/api.integration';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Router, ActivatedRoute } from '@angular/router';
import { Globals } from '../../_models/globals';
import { User } from '../../_models/user';
import * as _ from "lodash";
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-admin-user-role-edit',
  templateUrl: './admin-user-role-edit.component.html',
  styleUrls: ['./admin-user-role-edit.component.scss'],
})
export class AdminUserRoleEditComponent implements OnInit {
  auth: any;
  role = {
    name: "",
  };
  selectedRoles = [];
  statusText1: string = "";
  statusText2: string = "";
  statusText3: string = "";
  statusText4: string = "";
  viewUser: any = {};
  usersRoles: any;
  usersRole: any = {
    userRole: "",
  };
  constructor(private alertService: AlertService, private user: User, private http: HttpClient, private router: Router, private g: Globals, private api: ApiIntegration, public route: ActivatedRoute) {
    this.api.getAdminUserById(this.route.snapshot.params['id'], this.user.organizationId).subscribe((data: any) => {
      this.viewUser = data;
      this.usersRoles = _.cloneDeep(this.viewUser.usersRoles);
    }, err => {
      console.log(err);
    });

    this.api.getUserAuthorities().subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.auth = data;
    }, err => {
      this.g.loaderDisplay = "";
      this.alertService.error('Error', err);
    });

  }

  click() {
    if (this.role.name != "") {
      this.usersRole.userRole = this.role.name;
      this.usersRoles.push(_.cloneDeep(this.usersRole));
      this.role.name = "";
    }
  }

  ngOnInit() {
  }
  validateEmail() {
    this.g.loaderDisplay = "display";
    this.statusText4 = "";
    this.typeEmail();

    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    this.http.post(environment.apiUrl + 'api/uniqueEmail?email='+ this.viewUser.email + '&userType='+ 'USER',
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
        } else {
          if (data['code'] == 400) {
            this.statusText4 = data['message'];
          }
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          console.log(err);
          this.statusText4 = "uniqueEmail Failed, please re-try.";
        }
      )
  }

  validateMobile() {
    this.g.loaderDisplay = "display";
    this.statusText3 = "";
    this.typeMobile();
    if (!this.viewUser.mobile) {
      var header1 = new HttpHeaders();
      header1 = header1.append('Content-Type', 'application/json');
      header1 = header1.append('Accept', 'application/json');
      this.http.post(environment.apiUrl + 'api/uniqueMobileNumber',
        this.viewUser.mobile,
        { headers: header1 }).subscribe(data => {
          this.g.loaderDisplay = "";
          if (data['code'] == 200) {

          } else {
            if (data['code'] == 400) {
              this.statusText3 = data['message'];
            }
          }

        },
          (err: HttpErrorResponse) => {
            this.g.loaderDisplay = "";
            console.log(err);
            this.statusText3 = "Mobile Number  Exists";
          }
        )
    }
  }

  removeProduct(rp) {
    let index = this.usersRoles.indexOf(rp);
    this.usersRoles.splice(index, 1);
  }


  typeFirstName() {
    this.statusText1 = "";
    if (!this.viewUser.firstName) {
      this.statusText1 = 'Please enter first name';
    }
  }
  typeLastName() {
    this.statusText2 = "";
    if (!this.viewUser.lastName) {
      this.statusText2 = 'Please enter last name';
    }
  }
  typeMobile() {
    //this.statusText3="";
    if (!this.viewUser.mobile) {
      this.statusText3 = 'Please enter phone number';
      return false;
    } else if (this.viewUser.mobile.toString().length != 10) {
      this.statusText3 = 'phone number must be minimum 10 characters';
      return false;
    }
    let i = this.viewUser.mobile.toString().indexOf('0');
    if (i == 0) {
      this.statusText3 = "Number should not start with 0";
      return false;
    }
    return true;
  }
  typeEmail() {
    // this.statusText4="";
    if (!this.viewUser.email) {
      this.statusText4 = 'Please enter email address';
      return false;
    }
    return true;
  }

  submit() {
    this.g.loaderDisplay = "display";
    this.statusText1 = "";
    this.statusText2 = "";
    //this.statusText3="";
    //this.statusText4="";

    if (!this.viewUser.firstName) {
      this.statusText1 = 'Please enter first name';
    }
    if (!this.viewUser.lastName) {
      this.statusText2 = 'Please enter last name';
    }
    if (!this.viewUser.mobile) {
      this.statusText3 = 'Please enter phone number';
    } else if (this.viewUser.mobile.toString().length != 10) {
      this.statusText3 = 'phone number must be minimum 10 characters';
    }
    if (!this.viewUser.email) {
      this.statusText4 = 'Please enter email address';
    }

    if (this.statusText1 != "" || this.statusText2 != "" || this.statusText3 != "" || this.statusText4 != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));

    this.http.post(environment.apiUrl + 'api/editAdminUsers', {

      "email": this.viewUser.email,
      "firstName": this.viewUser.firstName,
      "lastName": this.viewUser.lastName,
      "mobile": this.viewUser.mobile,
      "organizationId": this.viewUser.organizationId,
      "role": this.usersRoles,
      "id": this.route.snapshot.params['id']

    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('User', 'Created Successfully');
          this.router.navigate(['/admin/userList']);
        }
        else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

}
